export class StudentSubjectRow {
  nendo: number
  subject_name: string
  sheets: any[]

  constructor(x: any){
    this.nendo = x.nendo;
    this.subject_name = x.subject_name;
    this.sheets = x.sheets.map((y: any) => y ? y : null);
  }
}